import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { Button } from "@mui/material";
import { AiOutlineBarcode } from "react-icons/ai";


const currencyFormatter = new Intl.NumberFormat('en-US', {
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});
const ArticleGridHeader = ({ handleOpenModal }) => [
    { field: 'id', headerName: '#', width: 30, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'Barcode', headerName: 'Barkodi', width: 150, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'ArticleName', headerName: 'Emri i Artikullit', width: 350, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'ArticleProduction', headerName: 'Lloji Artikullit', width: 148, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    {
        field: 'PurchasePrice', headerName: 'Cmimi Blerjës', type: 'string', width: 100, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
    {
        field: 'SalesPrice', headerName: 'Cmimi i Shitjes', type: 'string', width: 100, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
    // { field: 'active', headerName: 'Statusi', width: 100, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    {
        field: 'IsActive',
        headerName: 'Statusi',
        width: 70,
        headerClassName: 'super-app-theme--header',
        renderCell: (params) => (
            params.value ? <CheckCircleOutlineIcon style={{ color: "green" }} /> : ""
        )
    },
    {
        field: 'TouchScreen',
        headerName: 'POS',
        width: 70,
        headerClassName: 'super-app-theme--header',
        renderCell: (params) => (
            params.value ? <CheckCircleOutlineIcon style={{ color: "green" }} /> : ""
        )
    },
    {
        field: 'flags',
        headerName: 'Barkodi',
        width: 90,
        headerClassName: 'super-app-theme--header',
        renderCell: (params) => (
            <Button
                color="primary"
                size="small"
                className="article-barcode-action"
                aria-label="Hap barkodin e artikullit"
                onClick={(event) => {
                    event.stopPropagation();
                    handleOpenModal(params.row);
                }}
            >
                <AiOutlineBarcode className="article-barcode-action__icon" />
            </Button>
        )
    }

]

export default ArticleGridHeader
